/* 🤖 this file was generated by svg-to-ts */
export const iconEzeth: {
  name: 'ezeth';
  data: string;
} = {
  name: 'ezeth',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><path fill="#000" d="M16 0c8.84 0 16 7.126 16 15.925s-7.16 15.924-16 15.924S0 24.723 0 15.925C0 7.126 7.16 0 16 0"/><path fill="#CFFC79" d="m16 8.36-5.05 7.754 5.05-2.13z"/><path fill="#A3CE48" d="m16 18.85-5.05-2.746 5.05-2.12z"/><path fill="#CFFC79" d="m16 19.627-5.05-2.846L16 23.569z"/><path fill="#A3CE48" d="m16 8.36 5.05 7.754-5.05-2.13z"/><path fill="#CFFC79" d="m16 18.85 5.05-2.736-5.05-2.13z"/><path fill="#A3CE48" d="m16 19.627 5.05-2.797L16 23.57z"/></svg>`,
};
